import React, { Fragment, useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    Paper,
    Grid,
    Button,
    Typography
} from '@material-ui/core';

import { useStyles } from '../styles/Styles';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import Header from '../components/header/Header';
//import ActivateCardIcon from '../images/icons/ActivateATMCardIcon.png';
//import ChangePINIcon from '../images/icons/ChangePINIcon.png';
import ActivateCardIcon from '../images/icons/NominatePIN-Flexi.png';
import ChangePINIcon from '../images/icons/ChangePIN-Flexi.png';
import ChangeDebitPINIcon from '../images/icons/ChangePIN-DebitPrepaid.png';

const AccountServicesMain = () => {
    const classes = useStyles();
    const documentUploadContext = useContext(DocumentUploadContext);
    const { } = documentUploadContext;

    return (
        <>
            <Header page={1} />
            <div className={classes.banner}>
                <Grid container spacing={2} alignItems='baseline' justifyContent='center' >
                    {/* <Grid item md={4}>
                        <div className={classes.accountServicesLinkCenter}>
                            <img src={DocumentUploadIcon} style={{ width: '350px' }}/>
                            <Link className={classes.accountServicesLink} to='./DocumentUpload/'>Document Upload</Link>
                        </div>
                    </Grid> */}
                    <Grid item md={4} sm={12} xs={12}>
                        <div className={classes.accountServicesLinkCenter}>
                            <img src={ChangeDebitPINIcon} style={{ width: '325px' }} />
                            <br />
                            <p className={classes.accountServicesLink} style={{ margin: '0', marginTop: '7px' }}>
                                Change PIN - Debit/<br />Prepaid Card
                            </p>
                            <p style={{ margin: '7px 0 0 0' }}>
                                To change your PIN for these cards,<br />login to PSBank{" "}
                                <a href={process.env.REACT_APP_PSBM_LINK} className={classes.accountServicesLink} style={{ fontSize: '14px' }}>
                                    Mobile
                                </a>
                                {" or "}
                                <a href={process.env.REACT_APP_PSBO_LINK} className={classes.accountServicesLink} style={{ fontSize: '14px' }}>
                                    Online.
                                </a>
                            </p>
                        </div>
                    </Grid>
                    <Grid item md={4} sm={12} xs={12}>
                        <div className={classes.accountServicesLinkCenter}>
                            <img src={ActivateCardIcon} style={{ width: '325px' }} />
                            <br />
                            <Link className={classes.accountServicesLink}
                                to='/ActivateCard/'
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.location.href = '/ActivateCard/';
                                }}
                            >Nominate PIN - Flexi Card</Link>
                        </div>
                    </Grid>
                    <Grid item md={4} sm={12} xs={12}>
                        <div className={classes.accountServicesLinkCenter}>
                            <img src={ChangePINIcon} style={{ width: '325px' }} />
                            <br />
                            <Link className={classes.accountServicesLink} 
                            to='/ChangePIN/'
                            onClick={(e) => {
                                    e.preventDefault();
                                    window.location.href = '/ChangePIN/';
                                }}
                            >Change PIN - Flexi Card</Link>
                        </div>
                    </Grid>
                </Grid>
                <br /> <br />
            </div>
        </>
    );
};

export default AccountServicesMain;
